"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveBackground = exports.safeParseBackground = exports.DEFAULT_BACKGROUND = exports.DEFAULT_BACKGROUND_ITEM = exports.DEFAULT_BORDER_ITEM = exports.isArrayValue = exports.toArrayValue = void 0;
const brand_1 = require("../brand");
const id_1 = require("../utils/id");
const toArrayValue = (data) => ({ data, value: (0, id_1.generateId)() });
exports.toArrayValue = toArrayValue;
const isArrayValue = (value) => {
    return typeof value === 'object' && value !== null && 'data' in value && 'value' in value;
};
exports.isArrayValue = isArrayValue;
const DEFAULT_BORDER_ITEM = () => ({
    value: (0, id_1.generateId)(),
    data: {
        type: 'color',
        color: (0, brand_1.setThemeVariable)('borderColor'),
        blendMode: 'normal',
    },
});
exports.DEFAULT_BORDER_ITEM = DEFAULT_BORDER_ITEM;
const DEFAULT_BACKGROUND_ITEM = () => ({
    value: (0, id_1.generateId)(),
    data: {
        type: 'color',
        color: (0, brand_1.setThemeVariable)('lightBackgroundColor'),
        blendMode: 'normal',
    },
});
exports.DEFAULT_BACKGROUND_ITEM = DEFAULT_BACKGROUND_ITEM;
const DEFAULT_BACKGROUND = () => [(0, exports.DEFAULT_BACKGROUND_ITEM)()];
exports.DEFAULT_BACKGROUND = DEFAULT_BACKGROUND;
const safeParseBackground = (value) => {
    try {
        if (value) {
            return JSON.parse(value);
        }
        return null;
    }
    catch (_a) {
        return null;
    }
};
exports.safeParseBackground = safeParseBackground;
const saveBackground = (value) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
        return null;
    }
    if (Array.isArray(value)) {
        return JSON.stringify(value.map((item) => ((0, exports.isArrayValue)(item) ? item : (0, exports.toArrayValue)(item))));
    }
    return JSON.stringify([(0, exports.isArrayValue)(value) ? value : (0, exports.toArrayValue)(value)]);
};
exports.saveBackground = saveBackground;
